import { render, staticRenderFns } from "./DictCheckboxGroup.vue?vue&type=template&id=8c6f94b4&scoped=true&"
import script from "./DictCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./DictCheckboxGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6f94b4",
  null
  
)

export default component.exports